import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class NavigationTrackerService {
  private fromListingDetail = false;

  setFromListingDetail(value: boolean): void {
    this.fromListingDetail = value;
  }

  getIsFromListingDetail(): boolean {
    return this.fromListingDetail;
  }

  /** @deprecated Use setFromListingDetail */
  setFromAllMotorItem(value: boolean): void {
    this.setFromListingDetail(value);
  }

  /** @deprecated Use getIsFromListingDetail */
  getIsFromAllMotorItem(): boolean {
    return this.getIsFromListingDetail();
  }

  reset(): void {
    this.fromListingDetail = false;
  }
}
